'use client';
import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgSuperCoach = function SvgSuperCoach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.21 1.606a2.95 2.95 0 0 1 3.58 0l1.91 1.46 2.387.317a2.95 2.95 0 0 1 2.533 2.535l.315 2.38 1.46 1.912a2.95 2.95 0 0 1 0 3.58c-.721.942-1.457 1.906-1.462 1.91l-.318 2.386a2.95 2.95 0 0 1-2.535 2.533l-2.381.315h.003l-1.912 1.46a2.95 2.95 0 0 1-3.58 0l-1.91-1.46-2.387-.319a2.95 2.95 0 0 1-2.533-2.534l-.315-2.38-1.461-1.91a2.95 2.95 0 0 1 0-3.58c.722-.945 1.461-1.912 1.461-1.91l.32-2.387a2.95 2.95 0 0 1 2.534-2.532L8.3 3.066h-.003zm2.21 4.489a.963.963 0 0 0-1.27.414L9.803 9.112l-2.986.413a.96.96 0 0 0-.554.274.896.896 0 0 0 .032 1.296l2.15 1.994-.51 2.833a.9.9 0 0 0 .093.585.963.963 0 0 0 1.278.388l2.696-1.347 2.694 1.348a.98.98 0 0 0 .604.09.92.92 0 0 0 .767-1.063l-.51-2.834 2.15-1.994a.9.9 0 0 0 .285-.536c.072-.501-.289-.964-.807-1.034l-2.986-.413-1.349-2.603a.93.93 0 0 0-.428-.414",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgSuperCoach as default };
//# sourceMappingURL=super-coach.svg.js.map
